import { IS_LOAD_ASSETS_FROM_URL, STATIC_PATH } from "constants/common";

function formatNumber(n, symbol) {
  let parts = n ? n.toString().split(".") : "0";
  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, symbol) +
    (parts[1] ? "," + parts[1] : "")
  );
}

function urlAssetsCustom(path) {
  if (JSON.parse(IS_LOAD_ASSETS_FROM_URL)) {
    return STATIC_PATH + path;
  }
  return path;

}

export { formatNumber, urlAssetsCustom };
